import type { ComponentPropsWithRef } from 'react';

import { cn } from '@/lib/cn';

export interface LabelProps extends ComponentPropsWithRef<'label'> {
  required?: boolean;
}

export function Label({ required, className, children, ...props }: LabelProps) {
  return (
    <label className={cn('mb-1 block text-xs font-medium text-content', className)} {...props}>
      {children}
      {required && (
        <span className="ml-0.5 text-danger" aria-hidden="true">
          *
        </span>
      )}
    </label>
  );
}
